export const inTextEllipsisCenter = (text = '', initialChars = 4, lastChars = 4) => {
  if (text && text.length > initialChars + lastChars) {
    const trimmedText = text.trim();
    return `${trimmedText.slice(0, initialChars)}...${trimmedText.slice(-lastChars)}`;
  }
  return text;
};
